import { usePermissions } from "components/context/permissionsContext";

export const useEstimatePermission = () => {
  const { userPermissions } = usePermissions();

  const hasEstimateGetPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "Estimate" &&
      item.identifier === "estimate-get" &&
      item.hasPermission
  );
  const hasEstimateSavePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "Estimate" &&
      item.identifier === "estimate-save" &&
      item.hasPermission
  );
  const hasEstimateDeletePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "Estimate" &&
      item.identifier === "estimate-delete" &&
      item.hasPermission
  );

  const EstimatePermissionProps = {
    hasEstimateGetPermission,
    hasEstimateSavePermission,
    hasEstimateDeletePermission,
  };

  return {
    EstimatePermissionProps,
  };
};
